import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BudgetrequestReducer(state = initialState.glaccount, action: any) {
  switch (action.type) {
    case types.SAVE_GLACCOUNT_SUCCESS:
      return action.glaccount;
    default:
      return state;
  }
}
